<mat-nav-list>
  <a mat-list-item (click)="toggle('lyngbakkerne')">
    <div matListItemTitle>Lyngbakkerne</div>
    <div matListItemMeta>
      <mat-icon matListItemIcon *ngIf="expanded === 'lyngbakkerne'" class="material-icons">expand_more</mat-icon>
      <mat-icon matListItemIcon *ngIf="expanded !== 'lyngbakkerne'" class="material-icons">chevron_right</mat-icon>
    </div>
  </a>

  <mat-nav-list mat-list-item *ngIf="expanded === 'lyngbakkerne'">
    <a mat-list-item (click)="onClick()" routerLink="/lyngbakkerne/historie" routerLinkActive="active">Historie</a>
    <a mat-list-item (click)="onClick()" routerLink="/lyngbakkerne/biologi" routerLinkActive="active">Biologi</a>
    <a mat-list-item (click)="onClick()" routerLink="/lyngbakkerne/året" routerLinkActive="active">Året rundt</a>
    <a mat-list-item (click)="onClick()" routerLink="/lyngbakkerne/naturpleje" routerLinkActive="active">Naturpleje</a>
    <a mat-list-item (click)="onClick()" routerLink="/lyngbakkerne/overvågning" routerLinkActive="active">Overvågning</a>
  </mat-nav-list>

  <a mat-list-item (click)="toggle('støtteforeningen')">
    <div matListItemTitle>Støtteforeningen</div>
    <div matListItemMeta>
      <mat-icon *ngIf="expanded === 'støtteforeningen'" class="material-icons">expand_more</mat-icon>
      <mat-icon *ngIf="expanded !== 'støtteforeningen'" class="material-icons">chevron_right</mat-icon>
    </div>
  </a>

  <mat-nav-list mat-list-item *ngIf="expanded === 'støtteforeningen'">
    <a mat-list-item (click)="onClick()" routerLink="/støtteforeningen/medlemskab" routerLinkActive="active">Bliv medlem</a>
    <a mat-list-item (click)="onClick()" routerLink="/støtteforeningen/bestyrelse" routerLinkActive="active">Bestyrelse</a>
    <a mat-list-item (click)="onClick()" routerLink="/støtteforeningen/vedtægter" routerLinkActive="active">Vedtægter</a>
  </mat-nav-list>

  <a mat-list-item (click)="toggle('fonden')">
    <div matListItemTitle>Fonden</div>
    <div matListItemMeta>
      <mat-icon *ngIf="expanded === 'fonden'" class="material-icons">expand_more</mat-icon>
      <mat-icon *ngIf="expanded !== 'fonden'" class="material-icons">chevron_right</mat-icon>
    </div>
  </a>

  <mat-nav-list mat-list-item *ngIf="expanded === 'fonden'">
    <a mat-list-item (click)="onClick()" routerLink="/fonden/baggrund" routerLinkActive="active">Baggrund</a>
    <a mat-list-item (click)="onClick()" routerLink="/fonden/bestyrelse" routerLinkActive="active">Bestyrelse</a>
    <a mat-list-item (click)="onClick()" routerLink="/fonden/vedtægter" routerLinkActive="active">Vedtægter</a>
    <a mat-list-item (click)="onClick()" routerLink="/fonden/kontakt" routerLinkActive="active">Kontakt</a>
  </mat-nav-list>
</mat-nav-list>
